/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type CSSProperties, type ForwardedRef, type HTMLAttributes, createContext, forwardRef } from 'react';
import { type ContextValue, useContextProps } from 'react-aria-components';

interface ImageProps extends Omit<HTMLAttributes<HTMLImageElement>, 'style' | 'className'>, Pick<CSSProperties, 'objectFit'> {
  /** The URL of the image.*/
  src: string,
  /** Text description of the image.*/
  alt?: string,
  /**
   * Indicates if the fetching of the image must be done using a CORS request.
   * [See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/crossorigin).
   */
  crossOrigin?: 'anonymous' | 'use-credentials'
  style?: stylex.StyleXStyles;
}

const ImageContext = createContext<ContextValue<ImageProps, HTMLImageElement>>({});

const Image = forwardRef((props: ImageProps, ref: ForwardedRef<HTMLImageElement>) => {
  [props, ref] = useContextProps(props, ref, ImageContext);

  const { style, alt, src, objectFit, crossOrigin, ...coreProps } = props;

  return (
    <img
      ref={ref}
      src={src}
      style={{ objectFit }}
      crossOrigin={crossOrigin}
      aria-hidden={!alt}
      {...stylex.props(styles.base, style)}
      {...coreProps}
    />
  );
});

const styles = stylex.create({
  base: { overflow: 'hidden' },
});

export { Image, ImageContext, type ImageProps };
